<template>
  <div class="ppc-review-card h-full flex flex-col">
    <!-- Review message -->
    <p class="review-text text-left text-sm text-gray-700 flex-1 mb-6">"{{ review.testimonial }}"</p>

    <!-- Reviewer info -->
    <div class="flex items-center gap-3">
      <!-- Avatar circle -->
      <div class="reviewer-avatar flex-shrink-0">
        <img
          v-if="review.image"
          :src="review.image"
          :alt="review.name"
          class="w-full h-full object-cover rounded-full" />
        <span v-else class="initials-text">{{ initials }}</span>
      </div>

      <!-- Name + stars -->
      <div>
        <p class="font-semibold text-left text-sm text-gray-800 leading-tight mb-1">{{ review.name }}</p>
        <div class="flex">
          <star-icon
            v-for="i in 5"
            :key="i"
            :class="i <= review.rating ? 'checked' : 'unchecked'"
            class="review-star" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  review: {
    type: Object,
    required: true,
  },
});

const initials = computed(() => {
  return (
    props.review.name
      ?.split(" ")
      .map((n: string) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) ?? "?"
  );
});
</script>

<style scoped>
.ppc-review-card {
  background: #eef1f4;
  border-radius: 26px;
  padding: 24px;
}

.reviewer-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #4da43a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-weight: 600;
  font-size: 18px;
}

.initials-text {
  line-height: 1;
}

.review-star {
  font-size: 18px;
  color: #000;
}
</style>
